import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HedaCoreUtilModule } from '@heda/core-util';
import { FormsModule } from '@angular/forms';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { DictionaryService } from 'app/mdm/terminology/dictionary/services/dictionary.service';
import { DictionaryListComponent } from 'app/mdm/terminology/dictionary/containers/dictionary-list.component';
import { DictionaryEditComponent } from 'app/mdm/terminology/dictionary/containers/dictionary-edit.component';
import { DictionaryViewComponent } from 'app/mdm/terminology/dictionary/containers/dictionary-view.component';
import { DictionaryVersionViewComponent } from 'app/mdm/terminology/dictionary/containers/dictionary-version-view.component';
import { DictionaryConceptEditComponent } from 'app/mdm/terminology/dictionary/containers/dictionary-concept-edit.component';
import { DictionaryVersionDiffComponent } from 'app/mdm/terminology/dictionary/containers/dictionary-version-diff.component';
import { ConceptAttributesCardComponent } from 'app/mdm/terminology/dictionary/containers/concept-attributes-card.component';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';

export const DI_ROUTES: Routes = [
  { path: '', component: DictionaryListComponent },
  { path: 'view/:id', component: DictionaryViewComponent },
  { path: 'edit/:id', component: DictionaryEditComponent },
  { path: 'add', component: DictionaryEditComponent },

  { path: ':dictId/versions/view/:vers', component: DictionaryVersionViewComponent },
  { path: ':dictId/versions/diff/:vers/:vers2', component: DictionaryVersionDiffComponent },
  { path: ':dictId/versions/:vers/concepts/add', component: DictionaryConceptEditComponent },
  { path: ':dictId/versions/:vers/concepts/edit/:code', component: DictionaryConceptEditComponent },
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    HedaCoreHospitalUiModule,
    HedaCoreUtilModule,
    FormsModule,
    TerminologyLibModule,
  ],
  declarations: [
    DictionaryListComponent,
    DictionaryEditComponent,
    DictionaryViewComponent,
    DictionaryVersionViewComponent,
    DictionaryVersionDiffComponent,
    DictionaryConceptEditComponent,
    ConceptAttributesCardComponent,
  ],
  providers: [DictionaryService],
})
export class DictionaryModule {}
